/* eslint-disable */
/**
 * method命名规则
 * 取url中个性命名部分，使用大写驼峰进行组合，禁止个性化自定义名称，避免该配置文件丢失后，无法找回使用的方法名
 * 如：/api/v1/basic/data，/api/v1/为公共部分，取basic/data组成 BasicData
 */
module.exports = {
  apiConfig: [
    {
      name: '日志中心',
      method: 'Log',
      url: '/mix/api/v1/log/paging',
      type: 'post'
    },
    {
      name: '日志中心类别',
      method: 'LogCategory',
      url: '/mix/api/v1/log/category',
      type: 'get'
    },
    {
      name: '客户信息',
      method: 'Customer',
      url: 'mix/api/v1/customer',
      type: 'post'
    },
    {
      name: '客户信息-分页查询',
      method: 'CustomerPaging',
      url: '/mix/api/v1/customer/paging',
      type: 'post'
    },
    {
      name: '客户信息-下拉查询',
      method: 'CustomerList',
      url: '/mix/api/v1/customer/list',
      type: 'post'
    },
    {
      name: '项目信息',
      method: 'ProjectPaging',
      url: 'mix/api/v1/project/paging',
      type: 'post'
    },
    {
      name: '项目信息-同步Pm 项目数据',
      method: 'SyncProjectInfo',
      url: '/mix/api/v1/sync/project/info',
      type: 'post'
    },
    {
      name: '项目信息-项目类别',
      method: 'ProjectCategory',
      url: 'mix/api/v1/project/category',
      type: 'get'
    },
    {
      name: '项目信息-根据项目id获取数据',
      method: 'Project',
      url: 'mix/api/v1/project',
      type: 'get'
    },
    {
      name: '规则接口-告警规则',
      method: 'RuleAlarm',
      url: '/mix/api/v1/rule/alarm',
      type: 'get'
    },
    {
      name: '规则接口-发送规则',
      method: 'RuleSend',
      url: '/mix/api/v1/rule/send',
      type: 'get'
    },
    {
      name: '按类别统计获取日志',
      method: 'LogCategoryCount',
      url: '/mix/api/v1/log/category/count',
      type: 'post'
    },
    {
      name: '按小时统计获取日志',
      method: 'LogHourCount',
      url: '/mix/api/v1/log/hour/count',
      type: 'post'
    },
    {
      name: '分页获取日志(这个方法名字冲突，慎改)',
      method: 'LogV1Paging',
      url: '/mix/api/v1/log/paging',
      type: 'post'
    },
    {
      name: '按项目统计获取日志',
      method: 'LogProjectCount',
      url: '/mix/api/v1/log/project/count',
      type: 'post'
    },
    {
      name: '数据统计',
      method: 'IndexTopCount',
      url: '/mix/api/v1/index/top/count',
      type: 'get'
    },
    {
      name: '用户信息-列表',
      method: 'UserList',
      url: '/mix/api/v1/user/list',
      type: 'get'
    },
    {
      name: '服务器信息',
      method: 'ServerInfo',
      url: '/mix/api/v1/server/info/',
      type: 'get'
    },
    {
      name: '服务器信息-列表',
      method: 'Server',
      url: '/mix/api/v1/server/',
      type: 'get'
    },
    {
      name: '服务器信息-目录列表',
      method: 'ServerDirectoryList',
      url: '/mix/api/v1/server/directory/',
      type: 'get'
    },
    {
      name: '服务器信息-进程监控列表',
      method: 'ServerProcessList',
      url: '/mix/api/v1/server/process/',
      type: 'get'
    },
    {
      name: '服务器信息-值守服务信息监控列表',
      method: 'ServerSchedulerInfoList',
      url: '/mix/api/v1/server/scheduler/info/',
      type: 'get'
    },
    {
      name: '服务器信息-服务监控列表',
      method: 'ServerServiceList',
      url: '/mix/api/v1/server/service/',
      type: 'get'
    },
    {
      name: '服务器信息-服务监控列表',
      method: 'ServerCpuList',
      url: '/mix/api/v1/server/cpu',
      type: 'post'
    },
    {
      name: '告警信息',
      method: 'AlarmInfoPaging',
      url: 'mix/api/v1/alarm/info/paging',
      type: 'post'
    },
    {
      name: '告警信息-按项目统计',
      method: 'AlarmProjectCount',
      url: '/mix/api/v1/alarm/info/log/project/count',
      type: 'post'
    },
    {
      name: '告警信息-按小时统计',
      method: 'AlarmHourCount',
      url: '/mix/api/v1/alarm/info/log/hour/count',
      type: 'post'
    },
    {
      name: '告警信息-按类别统计',
      method: 'AlarmCategoryCount',
      url: '/mix/api/v1/alarm/info/log/category/count',
      type: 'post'
    },
    {
      name: '告警信息-分页查询（看板）',
      method: 'AlarmLogPaging',
      url: '/mix/api/v1/alarm/info/log/paging',
      type: 'post'
    },
    {
      name: '探针日志-详情',
      method: 'AgentLogInfo',
      url: '/mix/api/v1/agent/log/info',
      type: 'post'
    },
    {
      name: '探针日志-分页',
      method: 'AgentLogPaging',
      url: '/mix/api/v1/agent/log/paging',
      type: 'post'
    }
  ]
}
